var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.processedItems,"label":"グループ","prepend-icon":"group"},model:{value:(_vm.comboValue),callback:function ($$v) {_vm.comboValue=$$v},expression:"comboValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }